<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"><b></b> </span></p>
<p class="p4"><span class="sz"><b>PART ONE</b></span></p>
<p class="p4"><span class="sz"><b>THE MYSTERY</b></span></p>
<p class="p3"><span class="sz"><b></b> </span></p>
<p class="p3"><span class="sz"><b></b> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?832628d4